import { AlertCircle, CheckCircle, X } from "lucide-react";

/**
 * Dismissible alert banner for error and success messages.
 *
 * Props:
 *   type      - "error" | "success"
 *   message   - Message string; renders nothing when falsy
 *   onDismiss - Callback fired when the dismiss button is clicked
 */
const AlertBanner = ({ type, message, onDismiss }) => {
  if (!message) return null;

  const isError = type === "error";

  return (
    <div
      className={`flex items-start gap-3 rounded-xl border px-4 py-3 ${
        isError
          ? "bg-error-container/30 border-error/20 text-on-error-container"
          : "bg-secondary-container/30 border-secondary/20 text-on-secondary-container"
      }`}
    >
      {isError ? (
        <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0 text-error" />
      ) : (
        <CheckCircle className="w-4 h-4 mt-0.5 flex-shrink-0 text-secondary" />
      )}
      <div className="flex-1 min-w-0">
        <p className="text-xs font-bold uppercase tracking-wide">
          {isError ? "Error" : "Success"}
        </p>
        <p className="text-sm mt-0.5 leading-snug">{message}</p>
      </div>
      {onDismiss && (
        <button
          onClick={onDismiss}
          aria-label="Dismiss"
          className={`flex-shrink-0 p-1 rounded-lg transition-colors ${
            isError ? "hover:bg-error/10" : "hover:bg-secondary/10"
          }`}
        >
          <X className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
};

export default AlertBanner;
